<script>
export default {
  $_veeValidate: {
    name() {
      return this.name ? this.name : this.label;
    },
    value() {
      return this.value;
    }
  },

  props: {
    value: [String, Number],
    label: String,
    name: { type: String, required: false, default: null },
    type: { type: String, required: false, default: "text" },
    error: { type: String, required: false },
    customClasses: { type: String, required: false },
    mask: { type: [String, Array], required: false },
    masked: { type: Boolean, required: false, default: false },
    addon: { type: [String, Boolean], required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },

  data() {
    return {
      id:
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9)
    };
  },

  methods: {
    updateValue(e) {
      let value = this.mask || this.type === "money" ? e : e.target.value;
      this.$emit("input", value);
    }
  }
};
</script>

<template>
  <div class="input-group" :class="{'has-error': error}">
    <money
      v-if="type === 'money'"
      :value="value"
      :id="id"
      :class="customClasses"
      :disabled="disabled"
      @input="updateValue"
      @keyup.enter="$emit('keyupEnter')"
      @keyup="$emit('keyup')"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />

    <select
      v-else-if="type === 'select'"
      :value="value"
      :id="id"
      :class="customClasses"
      :disabled="disabled"
      @change="updateValue"
    >
      <slot name="options"/>
    </select>

    <the-mask
      v-else-if="mask"
      :value="value"
      :id="id"
      :type="type"
      :class="customClasses"
      :mask="mask"
      :masked="masked"
      :disabled="disabled"
      @input="updateValue"
      placeholder="."
      @keyup.enter="$emit('keyupEnter')"
      @keyup="$emit('keyup')"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />

    <input
      v-else
      :id="id"
      :value="value"
      :type="type"
      :class="customClasses"
      :disabled="disabled"
      @input="updateValue"
      placeholder="."
      @keyup.enter="$emit('keyupEnter')"
      @keyup="$emit('keyup')"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    >

    <label :for="id">{{label}}</label>

    <div v-if="addon" class="addon">
      <span>{{addon}}</span>
    </div>

    <transition name="fade" mode="out-in">
      <div class="error-button" v-if="error" v-tooltip.left="error">!</div>
    </transition>
  </div>
</template>

<style scoped>
.input-group {
  display: flex;
  height: 45px;
  margin-top: 8px;
  flex-flow: column-reverse;
  flex-grow: 1;
}

.input-group input,
.input-group select {
  flex: 1;
  margin: 0 5px;
  z-index: 1;
  background-color: transparent;
}

.input-group.has-error label {
  color: var(--pink) !important;
}

.input-group.has-error input,
.input-group.has-error select {
  border-bottom: 1px solid var(--pink) !important;
  color: var(--pink) !important;
}

.input-group input.with-icon + label,
.input-group select.with-icon + label {
  margin-left: 50px;
}

.input-group div.addon ~ input,
.input-group div.addon ~ select {
  padding-right: 130px;
}

.input-group div.addon {
  position: relative;
  top: 49px;
}

.input-group div.addon span {
  float: right;
  background: var(--purple);
  color: #fff;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 4px;
  margin-right: 5px;
  transition: all 0.24s ease;
}

.input-group.has-error div.addon span {
  background: var(--pink);
}

.input-group label {
  margin-left: 10px;
  font-size: 14px;
  color: #333;
  text-transform: lowercase;
  font-weight: 200;
  transition: all 0.25s ease;
  cursor: text;
  transform-origin: left bottom;
  transform: translate(0, 29px) scale(1);
  z-index: 1;
  user-select: none;
}

.input-group input::placeholder,
.input-group select::placeholder {
  opacity: 0;
}

.input-group input:focus + label,
.input-group input:not(:placeholder-shown) + label,
.input-group select:focus + label,
.input-group select:not(:placeholder-shown) + label {
  color: var(--purple);
  font-weight: 600;
  text-transform: uppercase;
  transform-origin: left bottom;
  transform: translate(0, 10px) scale(0.7);
}

.input-group input[disabled],
.input-group input[disabled]:focus + label,
.input-group input[disabled]:not(:placeholder-shown) + label,
.input-group select[disabled],
.input-group select[disabled]:focus + label,
.input-group select[disabled]:not(:placeholder-shown) + label {
  color: #999;
  cursor: default;
}

.icon-user {
  background: url("/static/icon_user.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.has-error .icon-user {
  background: url("/static/icon_user_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-password {
  background: url("/static/icon_password.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.has-error .icon-password {
  background: url("/static/icon_password_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/InputGroup.vue